// The booking lifecycle buttons — one grammar on the day sheet and the
// detail page: new → accept | reject (reason required); accepted →
// complete; both live states may cancel (reason optional). The server owns
// the state machine and refuses a stale transition (invalid_transition).

import type { BookingStatus, Refusal } from './types';

export type BookingTransition = 'accept' | 'reject' | 'cancel' | 'complete';

export function BookingActions(props: {
  status: BookingStatus;
  busy: boolean;
  small?: boolean;
  onAction: (event: BookingTransition, reason?: string) => void;
}) {
  const sz = props.small ? ' btn-sm' : '';
  const { status, busy, onAction } = props;
  return (
    <>
      {status === 'new' && (
        <>
          <button className={'btn btn-primary' + sz} disabled={busy} onClick={() => onAction('accept')}>
            Accept
          </button>
          <button
            className={'btn btn-danger' + sz}
            disabled={busy}
            onClick={() => {
              const reason = prompt('Reason for rejecting?');
              if (reason) onAction('reject', reason);
            }}
          >
            Reject
          </button>
        </>
      )}
      {status === 'accepted' && (
        <button className={'btn btn-primary' + sz} disabled={busy} onClick={() => onAction('complete')}>
          Complete
        </button>
      )}
      {(status === 'new' || status === 'accepted') && (
        <button
          className={'btn btn-outline' + sz}
          disabled={busy}
          onClick={() => {
            const reason = prompt('Reason for cancelling?');
            if (reason !== null) onAction('cancel', reason);
          }}
        >
          Cancel
        </button>
      )}
    </>
  );
}

/** The server's refusal, its typed code on `data-code`. */
export function RefusalBox({ refusal }: { refusal: Refusal | null }) {
  if (!refusal) return null;
  return (
    <div className="err" role="alert" data-code={refusal.code}>
      {refusal.message}
    </div>
  );
}

export function StatusChip({ status }: { status: BookingStatus }) {
  return (
    <span className={`chip chip-${status}`} data-status={status}>
      {status}
    </span>
  );
}
